<template>
  <div class="nftset">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>NFT管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page-actions" style="margin-top: 10px;margin-bottom: 10px">
      <el-button type="primary" @click="add">创建NFT</el-button>
      <el-button type="primary" @click="openSyncDialog">同步NFT数据</el-button>
      <el-upload
          ref="upload"
          class="upload-demo"
          action="/admin/blindBoxCoin/import/coin"
          :limit="1"
          :headers="{
            'Authorization': token
          }"
          accept=".xls, .xlsx"
          :on-exceed="fileOnExceed"
          :on-success="fileSuccess"
          :on-error="fileError"
      >
        <el-button type="primary">导入NFT</el-button>
      </el-upload>

      <a href="https://alpha-dev-pub-hz.oss-accelerate.aliyuncs.com/pc/common/20211230193413/656.xls" class="download" download="导入模板.xlsx">导入模板下载</a>
    </div>
    <div class="page-actions">
      <el-input v-model="nftName" placeholder="名称" />
      <el-select v-model="status" placeholder="请选择状态">
        <el-option
          v-for="item in statusList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-button type="primary" @click="getList">查询</el-button>
      <el-button @click="reset">重置</el-button>
    </div>
    <el-card class="page-content" shadow="never">
      <div class="list">
        <el-table :data="listData" border style="width: 100%">
          <el-table-column prop="id" label="系统序号" width="80" />
          <el-table-column prop="rewardName" label="名称" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <!-- <span>{{scope.row.blindBoxName | langFormat}}</span> -->
              <span v-for="(item, index) in scope.row.nameObj" :key="index">
                <span v-if="item.lang === 'zh'">{{ item.name }}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="等级">
            <template slot-scope="scope">
              <span v-if="scope.row.grade === 1">1星</span>
              <span v-if="scope.row.grade === 2">2星</span>
              <span v-if="scope.row.grade === 3">3星</span>
              <span v-if="scope.row.grade === 4">4星</span>
              <span v-if="scope.row.grade === 5">5星</span>
            </template>
          </el-table-column>
          <el-table-column prop="contractAddress" label="合约地址" />
          <el-table-column prop="coinId" label="Token ID" />
          <el-table-column prop="chainType" label="所属链" />
          <el-table-column prop="creator" label="创作者" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <!-- <span>{{scope.row.blindBoxName | langFormat}}</span> -->
              <span v-for="(item, index) in scope.row.creatorObj" :key="index">
                <span v-if="item.lang === 'zh'">{{ item.name }}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="picLinkUrl" label="图片链接" />
          <el-table-column label="图片">
            <template slot-scope="scope">
              <img :src="scope.row.picUrl" width="30" />
            </template>
          </el-table-column>
          <el-table-column prop="describeInfo" label="描述" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <!-- <span>{{scope.row.blindBoxName | langFormat}}</span> -->
              <span v-for="(item, index) in scope.row.descObj" :key="index">
                <span v-if="item.lang === 'zh'">{{ item.name }}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.state === 0">未被抽中</span>
              <span v-if="scope.row.state === 1">已被抽中</span>
              <span v-if="scope.row.state === 2">申请提现</span>
              <span v-if="scope.row.state === 3">提现成功</span>
              <span v-if="scope.row.state === 4">提现失败</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="220">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.state === 0"
                @click="editItem(scope.row)"
                type="primary"
                size="mini"
                plain
              >编辑</el-button>
              <el-button
                v-if="scope.row.state === 2"
                @click="getapply(scope.row)"
                type="primary"
                size="mini"
                plain
              >查看提现申请</el-button>
              <el-button
                v-if="scope.row.state === 2"
                @click="hashBox(scope.row)"
                type="primary"
                size="mini"
                plain
              >上传哈希</el-button>
              <el-button
                v-if="scope.row.state === 3"
                @click="getvoucher(scope.row)"
                type="primary"
                size="mini"
                plain
              >查看提现凭证</el-button>
              <el-button
                v-if="scope.row.state === 0"
                @click="delItem(scope.row)"
                type="danger"
                size="mini"
                plain
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        :size="pagination.size"
        :page="pagination.page"
        :total="total"
        @pageChanged="handlePageChanged"
      ></pagination>
    </el-card>
    <el-dialog title="上传哈希" :visible.sync="boxShow" width="500px">
      <el-form :model="form" ref="form" label-width="100px">
        <el-form-item label="网络" prop="natwork">
          <el-select v-model="form.chainType" placeholder="请选择网络">
            <el-option v-for="item in chainTypeList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易哈希" prop="natwork">
          <el-input class="width300" v-model="form.hash" placeholder="请输入hash" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isClose">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
    <!--创建弹框-->
    <Info :boxShow="isShow" :title="title" @closeBox="closeBox" @submit="submit" :row="row" :editStatus="editStatus" />
    <el-dialog title="查看提现申请" :visible.sync="isApply" width="500px">
      <div>
        <span>用户账号：</span>
        <span class="text">{{apply.userId}}</span>
        <img src="../../assets/images/copy.png" width="16px" @click="copyUserId" />
      </div>
      <div class="trade-hash">
        <span>提现地址：</span>
        <span class="addtext hashtext">{{apply.withdrawalAddress}}</span>
        <img src="../../assets/images/copy.png" width="16px" @click="copyAddress" />
      </div>
      <div>
        <span>发起提现时间：</span>
        {{ apply.withdrawalApplyTime }}
      </div>
      <div>
        <span>系统序号：</span>
        {{apply.id}}
      </div>
      <div>
        <span>名称：</span>
        <span v-for="(item, index) in apply.nameObj" :key="index">
          <span v-if="item.lang === 'zh'">{{ item.name }}</span>
        </span>
      </div>
      <div>
        <span>合约地址：</span>
        {{apply.contractAddress}}
      </div>
      <div>
        <span>tokenID：</span>
        {{apply.coinId}}
      </div>
      <div>
        <span>所属链：</span>
        {{apply.chainType}}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="isApply = false">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看提现凭证" :visible.sync="isVoucher" width="500px">
      <div>
        <span>网络：</span>
        {{voucher.chainType}}
      </div>
      <div class="trade-hash">
        <span>交易哈希：</span>
        <span class="hashtext">{{voucher.hash}}</span>
        <img src="../../assets/images/copy.png" width="16px" @click="copyHash" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="isVoucher = false">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="同步NFT数据" :visible.sync="syncDialog" width="500px" custom-class="sync-dialog">
      <el-form :model="syncData" label-width="90px" :rules="rules" ref="syncForm">
        <el-form-item label="所属链" prop="chainType">
          <el-select v-model="syncData.chainType" clearable>
            <el-option v-for="(item, index) in chainTypeList" :key="item + index" :label="item" :value="item">{{item}}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合约地址" prop="contractAddress">
          <el-input v-model="syncData.contractAddress" clearable placeholder="请输入合约地址"></el-input>
        </el-form-item>
      </el-form>
      <div class="footer" slot="footer">
        <el-button type="primary" @click="syncNftData">同步NFT数据</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "../../components/pagination";
import Info from "./components/info";
import "./store";
import { mapState, mapActions } from "vuex";
import api from "./api";
import moment from 'moment';
import userInfoHelper from 'common/userInfo';
export default {
  components: {
    Pagination,
    Info
  },
  data() {
    return {
      nftName: "",
      status: "",
      statusList: [
        // {
        //   label: "全部",
        //   value: 0
        // },
        {
          label: "未被抽中",
          value: 0
        },
        {
          label: "已被抽中",
          value: 1
        },
        {
          label: "申请提现",
          value: 2
        },
        {
          label: "提现成功",
          value: 3
        },
        {
          label: "提现失败",
          value: 4
        }
      ],
      orderListData: [
        {
          boxName: "白银1号",
          level: 1,
          total: 100,
          surplus: 50,
          desc: "这是为了反抗旧世界的压迫为了新世界的启蒙而创作的作品",
          beginTime: 1638594041352,
          endTime: 1638594041352,
          status: 1
        },
        {
          boxName: "白银1号",
          level: 2,
          total: 100,
          surplus: 50,
          desc: "这是为了反抗旧世界的压迫为了新世界的启蒙而创作的作品",
          beginTime: 1638594041352,
          endTime: 1638594041352,
          status: 2
        },
        {
          boxName: "白银1号",
          level: 3,
          total: 100,
          surplus: 50,
          desc: "这是为了反抗旧世界的压迫为了新世界的启蒙而创作的作品",
          beginTime: 1638594041352,
          endTime: 1638594041352,
          status: 3
        }
      ],
      boxShow: false,
      isShow: false,
      isApply: false,
      isVoucher: false,
      title: "创建NFT",
      form: {},
      row: {},
      chainTypeList: [],
      apply: {},
      voucher: {},
      hashId: "",
      editStatus: false,
      syncDialog: false,
      syncData: {
        chainType: '',
        contractAddress: ''
      },
      rules: {
        chainType: { required: true, message: '请选择所属链', trigger: 'blur' },
        contractAddress: { required: true, message: '请输入合约地址', trigger: 'blur' }
      },
      token: userInfoHelper.get().accessToken,
    };
  },
  computed: {
    ...mapState("nft", ["listData", "pagination", "total"])
  },
  methods: {
    ...mapActions("nft", ["getNFTListA"]),
    reset() {
      this.status = "";
      this.nftName = "";
    },
    getList(data = {}) {
      this.getNFTListA({
        state: this.status,
        rewardName: this.nftName,
        ...this.pagination,
        ...data
      });
    },
    handlePageChanged(pageVal) {
      this.getList(pageVal);
    },
    hashBox(row) {
      console.log(row);
      this.boxShow = true;
      this.hashId = row.id;
      console.log(this.hashId);
    },
    isClose() {
      this.boxShow = false;
    },
    add() {
      this.isShow = true;
      this.title = "创建NFT";
    },

    closeBox() {
      this.isShow = false;
      this.editStatus = false
      // if (this.title != "创建NFT") {
      //   this.$router.go(0)
      // }
    },
    submit() {
      this.isShow = false;
      // if (val) {
      //   setTimeout(this.getList(), 3000);
      // }
    },
    editItem(row) {
      this.row = row;
      this.isShow = true;
      this.editStatus = true
      this.title = "编辑NFT";
    },
    getChainTypeList() {
      api.getChainType().then(res => {
        this.chainTypeList = res.data;
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = this.form;
          data.id = this.hashId;
          api.createHash(data).then(res => {
            this.$message({
              message: "上传成功",
              type: "success"
            });
            this.boxShow = false
            this.form = {}
            this.getList()
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      this.$emit("submit");
    },
    getapply(row) {
      api.getApply({ id: row.id }).then(res => {
        this.isApply = true;
        res.data.rewardName = res.data.rewardName ? JSON.parse(res.data.rewardName) : "";
        let nameObj = Object.keys(res.data.rewardName).map(v => ({lang: v, name: res.data.rewardName[v]}))
        res.data.withdrawalApplyTime = moment(res.data.withdrawalApplyTime).format("YYYY-MM-DD HH:mm:ss")
        this.apply = res.data;
        this.$set(this.apply, "nameObj", nameObj);
      });
    },
    getvoucher(row) {
      api.getVoucher({ id: row.id }).then(res => {
        this.isVoucher = true;
        this.voucher = res.data;
        console.log(res.data);
      });
    },
    delItem(row) {
      this.$confirm("删除后不可回复，确认删除吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info"
      }).then(() => {
        api.deleteNFT(row.id).then(res => {
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.getList();
        });
      });
    },
    copyUserId() {
      const copyEle = document.querySelector(".text"); // 获取要复制的节点
      const range = document.createRange(); // 创建一个range
      window.getSelection().removeAllRanges(); // 清除页面中已有的selection
      range.selectNode(copyEle); // 选中需要复制的节点
      window.getSelection().addRange(range); // 执行选中元素
      const successful = document.execCommand("copy"); // 执行copy操作
      if (successful) {
        this.$message({
          message: "复制成功",
          type: "success"
        });
      }
      window.getSelection().removeAllRanges(); // 清除页面中已有的selection
    },
    copyAddress() {
      const copyEle = document.querySelector(".addtext"); // 获取要复制的节点
      const range = document.createRange(); // 创建一个range
      window.getSelection().removeAllRanges(); // 清除页面中已有的selection
      range.selectNode(copyEle); // 选中需要复制的节点
      window.getSelection().addRange(range); // 执行选中元素
      const successful = document.execCommand("copy"); // 执行copy操作
      if (successful) {
        this.$message({
          message: "复制成功",
          type: "success"
        });
      }
      window.getSelection().removeAllRanges(); // 清除页面中已有的selection
    },
    copyHash() {
      const copyEle = document.querySelector(".hashtext"); // 获取要复制的节点
      const range = document.createRange(); // 创建一个range
      window.getSelection().removeAllRanges(); // 清除页面中已有的selection
      range.selectNode(copyEle); // 选中需要复制的节点
      window.getSelection().addRange(range); // 执行选中元素
      const successful = document.execCommand("copy"); // 执行copy操作
      if (successful) {
        this.$message({
          message: "复制成功",
          type: "success"
        });
      }
      window.getSelection().removeAllRanges(); // 清除页面中已有的selection
    },
    openSyncDialog() {
      this.syncData = { chainType: '', contractAddress: ''}
      this.$refs.syncForm &&  this.$refs.syncForm.clearValidate()
      this.syncDialog = true
    },
    // 同步NFT数据
    syncNftData() {
      this.$refs.syncForm.validate(flag => {
        if (flag) {
          api.syncNftBox(this.syncData).then( res => {
            if (res.code === 0) {
              this.getList()
              this.$message({ message: 'NFT同步成功', type: 'success' })
            }
          })
        }
      })
    },
    fileOnExceed() {
      this.$message({ message: '文件最大上传数为1', type: 'warning' })
    },
    fileSuccess(res) {
      if (res.code !== 0) {
        this.$message({ message: res.msg, type: 'error' })
        this.$refs.upload && this.$refs.upload.clearFiles()
      } else {
        this.getList()
        this.$message({ message: '文件导入成功', type: 'success' })

      }

    },
    fileError() {
      this.$message({ message: '文件导入失败', type: 'error' })
      this.$refs.upload && this.$refs.upload.clearFiles()
    }
  },
  mounted() {
    this.getList();
    this.getChainTypeList();
  }
};
</script>
<style lang="less">
.nftset {
  .page-actions {
    .el-button + .el-button {
      margin-left: 0;
    }
    .el-upload-list__item {
      line-height: 20px;
      width: auto;
      position: absolute;
      margin-top: 0;
    }
    .download {
      color: #fff;
      font-size: 14px;
      font-weight: 400;
      padding: 0 20px;
      background: #409EFF;
      border-radius: 4px;
      display: inline-block;
      height: 40px;
      line-height: 40px;
      &:hover, &:active {
        color: #fff;
      }
    }
  }
  .list {
    .el-button + .el-button {
      margin-left: 10px;
    }
  }
  .el-input {
    width: 100px;
  }
  .page-actions {
    .el-input {
      min-width: 200px;
    }
    .el-input__inner {
      width: 200px;
    }
  }
  .el-input__inner {
    width: 100px;
  }
  .el-input.width300 {
    width: 350px;
    .el-input__inner {
      width: 100%;
    }
  }
  .el-pagination__editor.el-input {
    width: 50px;
  }
  .el-pagination__jump .el-input__inner {
    width: auto;
  }
  .sync-dialog {
    .el-form-item__label {
      width: 90px;
    }
    .el-input, .el-select, .el-input__inner {
      width: 300px;
    }
  }
  .el-dialog {
    .trade-hash {
      overflow: hidden;
      span {
        float: left;
        width: 70px;
        &.hashtext {
          width: auto;
          max-width: calc(100% - 90px);
          word-wrap: break-word;
        }
      }
      img {
        float: left;
      }
    }
  }
}
</style>